var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49684 4.2662C5.84688 4.6191 5.84456 5.18895 5.49166 5.53898C3.82833 7.18881 2.79988 9.47346 2.79988 12C2.79988 14.5265 3.82833 16.8112 5.49164 18.461C5.84454 18.811 5.84686 19.3809 5.49682 19.7338C5.14678 20.0867 4.57694 20.089 4.22404 19.739C2.23396 17.765 0.999878 15.0258 0.999878 12C0.999878 8.9742 2.23397 6.23496 4.22406 4.26102C4.57696 3.91098 5.14681 3.9133 5.49684 4.2662Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5009 4.2662C18.8509 3.9133 19.4208 3.91098 19.7737 4.26102C21.7638 6.23496 22.9979 8.9742 22.9979 12C22.9979 15.0258 21.7638 17.765 19.7737 19.739C19.4208 20.089 18.851 20.0867 18.5009 19.7338C18.1509 19.3809 18.1532 18.811 18.5061 18.461C20.1694 16.8112 21.1979 14.5265 21.1979 12C21.1979 9.47346 20.1694 7.18881 18.5061 5.53898C18.1532 5.18895 18.1508 4.6191 18.5009 4.2662Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13434 7.24303C8.49718 7.58276 8.51591 8.1523 8.17618 8.51513C7.32174 9.42769 6.79988 10.6519 6.79988 12C6.79988 13.3223 7.30059 14.6085 8.09829 15.4998C8.42978 15.8701 8.39826 16.4391 8.02789 16.7706C7.65751 17.1021 7.08854 17.0706 6.75704 16.7002C5.65457 15.4684 4.99988 13.7511 4.99988 12C4.99988 10.1772 5.70791 8.51771 6.86224 7.28487C7.20197 6.92203 7.77151 6.9033 8.13434 7.24303Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8648 7.24303C16.2277 6.9033 16.7972 6.92203 17.1369 7.28487C18.2913 8.51771 18.9993 10.1772 18.9993 12C18.9993 13.7511 18.3446 15.4684 17.2421 16.7002C16.9106 17.0706 16.3417 17.1021 15.9713 16.7706C15.6009 16.4391 15.5694 15.8701 15.9009 15.4998C16.6986 14.6085 17.1993 13.3223 17.1993 12C17.1993 10.6519 16.6774 9.42769 15.823 8.51513C15.4833 8.1523 15.502 7.58276 15.8648 7.24303Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1045 13.1045 14 12 14C10.8954 14 9.99998 13.1045 9.99998 12C9.99998 10.8954 10.8954 9.99998 12 9.99998C13.1045 9.99998 14 10.8954 14 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastOutline);
export default __webpack_public_path__ + "static/media/broadcast_outline.7f4ea5c9aaae3e55dd52c4efa2f720ec.svg";
export { ForwardRef as ReactComponent };